export default __webpack_public_path__ + "static/media/tcblogo.3bdc40f2.png";